<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (workflow) {
  <form
    class="modal-content"
    #f="ngForm"
    (ngSubmit)="f.valid && !savingWorkflow && saveWorkflow(f)"
    (keydown.enter)="handleEnterKeyPress($event)">
    <div class="modal-header">
      <div class="workflow-title">
        <div
          class="modal-title"
          [xdaTranslate]="
            isNew
              ? 'SDE_CREATE_AUTOMATED_WORKFLOW'
              : 'SDE_EDIT_AUTOMATED_WORKFLOW'
          "></div>
      </div>
    </div>
    <div class="modal-body" tabindex="-1">
      <!-- Summary cards -->
      <section
        class="section-summary"
        [ngClass]="{
          'xs-summary-collapsed': xsSummaryCollapsed,
          'xs-summary-expanded': !xsSummaryCollapsed,
        }">
        <div
          class="card xrx-btn btn-secondary xs-summary-toggle d-none"
          (click)="xsSummaryCollapsed = !xsSummaryCollapsed">
          <div class="card-label">
            <span
              class="label-left xglsize-24"
              [ngClass]="{
                'xgl-align_right': xsSummaryCollapsed,
                'xgl-align_left': !xsSummaryCollapsed,
              }"></span>
          </div>
        </div>
        @for (step of steps; track step; let i = $index; let last = $last) {
          <div>
            @if (!step.hidden) {
              <div
                class="card xrx-btn btn-secondary"
                [ngClass]="{
                  selected: step.mode === StepMode.Edit,
                  disabled: step.mode === StepMode.Disabled,
                }"
                (click)="stepTo(step)">
                <div class="card-label">
                  <span
                    class="label-left xglsize-24"
                    [ngClass]="step.glyph"></span>
                  <span class="label" [xdaTranslate]="step.label"></span>
                  <span
                    class="label-right xglsize-24"
                    [ngClass]="statusGlyph(step)"></span>
                </div>
                @if (
                  step.status === StepStatus.Invalid ||
                  (step.status === StepStatus.Warning &&
                    step.mode != StepMode.Edit)
                ) {
                  <div
                    class="card-detail"
                    [ngClass]="{
                      error: step.status === StepStatus.Invalid,
                      warning: step.status === StepStatus.Warning,
                    }">
                    <div
                      [xdaTranslate]="
                        step.status == StepStatus.Invalid
                          ? 'SDE_ERRORS_FOUND1'
                          : 'SDE_DEFAULT_SETTINGS_APPLIED'
                      "></div>
                  </div>
                }
                @if (
                  step.status === StepStatus.Valid ||
                  step.status === StepStatus.Warning
                ) {
                  <div class="card-detail">
                    @if (step.name == 'input') {
                      <div>
                        @if (inputSource?.value == 'SDE_CLOUD_REPO') {
                          <div>
                            <div>
                              <span
                                [xdaTranslate]="
                                  selectedInputCloudRepo?.key || ''
                                "></span>
                            </div>
                            <div>
                              <span [xdaTranslate]="'SDE_FOLDER'"></span>
                              <span>:&nbsp;</span>
                              <span
                                [xdaTranslate]="
                                  selectedInputCloudFolder?.name || ''
                                "></span>
                            </div>
                          </div>
                        }
                        @if (inputSource?.value == 'SDE_EMAIL2') {
                          <div>
                            <div>
                              <span [xdaTranslate]="'SDE_EMAIL2'"></span>
                            </div>
                            <div>
                              <span [xdaTranslate]="'SDE_ADDRESS'"></span>
                              <span
                                >:&nbsp;{{ emailOptions.emailAddress }}</span
                              >
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (step.name == 'conditions') {
                      <div>
                        <div>
                          <span [xdaTranslate]="'SDE_OCCURRENCE'"></span>
                          <span>:&nbsp;</span>
                          <span [xdaTranslate]="occurrenceOption.label"></span>
                        </div>
                        @if (occurrenceOption.value == 2) {
                          <div>
                            <span [xdaTranslate]="'SDE_DAY'"></span>
                            <span>:&nbsp;</span>
                            <span
                              [xdaTranslate]="selectedDayOfTheWeek.key"></span>
                          </div>
                        }
                        @if (occurrenceOption.value >= 1) {
                          <div>
                            <span [xdaTranslate]="'SDE_TIME1'"></span>
                            <span
                              >&nbsp;{{ occurrenceTime.hour }}:{{
                                occurrenceTime.minute
                              }}&nbsp;</span
                            >
                            @if (occurrenceTime.ampm == 'am') {
                              <span [xdaTranslate]="'SDE_AM'"></span>
                            }
                            @if (occurrenceTime.ampm == 'pm') {
                              <span [xdaTranslate]="'SDE_PM'"></span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (step.name == 'workflow' && selectedWorkflow) {
                      <div>
                        <div>
                          <span
                            [xdaTranslate]="selectedWorkflow.name || ''"></span>
                        </div>
                      </div>
                    }
                    @if (step.name == 'output') {
                      <div>
                        @if (outputOption?.value == 'Cloud') {
                          <div>
                            <div>
                              <span
                                [xdaTranslate]="
                                  selectedOutputCloudRepo?.key || ''
                                "></span>
                            </div>
                            <div>
                              <span [xdaTranslate]="'SDE_FOLDER'"></span>
                              <span>:&nbsp;</span>
                              <span
                                [xdaTranslate]="
                                  output?.currentCloudRepo?.dir?.name || ''
                                "></span>
                            </div>
                          </div>
                        }
                        @if (outputOption?.value == 'Email') {
                          <div>
                            <div>
                              <span [xdaTranslate]="'SDE_EMAIL2'"></span>
                            </div>
                            <div>
                              <span [xdaTranslate]="'SDE_ADDRESS'"></span
                              ><span>:&nbsp;{{ output.email }}</span>
                            </div>
                          </div>
                        }
                        @if (output.fileTypes.extension?.value) {
                          <div>
                            <span [xdaTranslate]="'SDE_FILE_TYPE'"></span>
                            <span>:&nbsp;</span>
                            @if (!isTranslateWorkflow) {
                              <span
                                [xdaTranslate]="
                                  output.fileTypes.extension?.value
                                "></span>
                            }
                            @if (isTranslateWorkflow) {
                              <span
                                [xdaTranslate]="
                                  selectedTranslateFileType.display
                                "></span>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (step.name == 'name' && workflow.icon) {
                      <div>
                        <div class="name-detail">
                          @if (workflow.icon.image) {
                            <img
                              class="workflow-image"
                              [src]="workflow.icon.image" />
                          } @else {
                            <div
                              class="workflow-image {{ workflow.icon.glyph }} {{
                                workflow.icon.color
                              }} xglsize-32 text-center align-middle"></div>
                          }
                          <span>{{ workflowName }}</span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (!last && !step.hidden) {
              <div class="v-divider"></div>
            }
          </div>
        }
      </section>
      <!-- Right side settings-->
      <section
        class="section-settings"
        [ngClass]="{ 'd-none': !xsSummaryCollapsed }">
        @switch (step.name) {
          <!-- Input settings -->
          @case ('input') {
            <div class="settings">
              <div class="form-group">
                <h5 class="section-label" [xdaTranslate]="'SDE_E2_INPUT'"></h5>
              </div>
              <div class="form-group input-settings">
                <div class="input-selection">
                  <xrx-radio
                    display="inline"
                    [list]="inputSourceOptions"
                    property="value"
                    localize="label"
                    [(checkedItem)]="inputSource">
                  </xrx-radio>
                </div>
                <!-- cloud repo -->
                @if (inputSource.value == 'SDE_CLOUD_REPO') {
                  <div class="input-choice">
                    <label [xdaTranslate]="'SDE_LOCATION'"></label>
                    <xrx-select
                      inlineLabel="SDE_SELECT_REPOSITORY"
                      [list]="cloudRepos"
                      localize="key"
                      property="key"
                      [(selectedItem)]="selectedInputCloudRepo"
                      (change)="selectCloudRepo($event)"></xrx-select>
                    <div>
                      @if (
                        selectedInputCloudRepo &&
                        !input?.currentCloudRepo?.access
                      ) {
                        <div class="mt-2">
                          <label
                            class="select-folder"
                            [ngClass]="{ 'invalid-options': !isNew }"
                            xdaTranslate
                            >SDE_SIGN_SELECT_FOLDER</label
                          >
                          <button
                            type="button"
                            class="xrx-btn btn-secondary btn"
                            [ngClass]="
                              selectedInputCloudRepo.value === 'GoogleDrive'
                                ? 'google icon-button'
                                : 'microsoft'
                            "
                            (click)="signInRepo(selectedInputCloudRepo)">
                            @if (
                              selectedInputCloudRepo.value === 'GoogleDrive'
                            ) {
                              <span class="google-icon"></span>
                            }
                            <span
                              [xdaTranslate]="
                                selectedInputCloudRepo.value === 'GoogleDrive'
                                  ? 'Google'
                                  : selectedInputCloudRepo.key
                              "></span>
                          </button>
                          @if (this.inputCloudRepoIsInvalid) {
                            <label class="invalid-options mt-1" xdaTranslate
                              >SDE_SIGN_CONTINUE</label
                            >
                          }
                        </div>
                      }
                      @if (
                        selectedInputCloudRepo &&
                        input?.currentCloudRepo?.access
                      ) {
                        <div>
                          @if (selectedInputCloudFolder) {
                            <div class="selected-cloud-folder form-inline">
                              <div
                                class="form-control d-flex align-items-center">
                                <span
                                  class="xglsize-24"
                                  [ngClass]="
                                    selectedInputCloudFolder.type === 'lib'
                                      ? 'xgl-accounting'
                                      : 'xgl-folder'
                                  "></span>
                                <span
                                  class="cloud-folder-name text-truncate"
                                  [xdaTranslate]="
                                    selectedInputCloudFolder.name
                                  "></span>
                              </div>
                              <button
                                type="button"
                                class="xrx-btn btn-secondary ml-2"
                                (click)="
                                  changeInputCloudFolder(selectedInputCloudRepo)
                                "
                                xdaTranslate>
                                SDE_CHANGE
                              </button>
                            </div>
                          }
                          @if (!selectedInputCloudFolder) {
                            <div class="selected-cloud-folder">
                              <button
                                type="button"
                                class="xrx-btn btn-secondary"
                                (click)="
                                  changeInputCloudFolder(selectedInputCloudRepo)
                                "
                                xdaTranslate>
                                SDE_SELECT_FOLDER
                              </button>
                              <div>
                                @if (this.inputCloudRepoIsInvalid) {
                                  <label
                                    class="invalid-options mt-1"
                                    xdaTranslate
                                    >SDE_SELECT_FOLDER1</label
                                  >
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @if (
                        selectedInputCloudRepo &&
                        selectedInputCloudRepo.value === 'GoogleDrive' &&
                        !selectedInputCloudFolder
                      ) {
                        <span
                          class="google-policy"
                          [innerHtml]="googlePolicyStr"></span>
                      }
                      @if (selectedInputCloudRepo) {
                        <label class="info" xdaTranslate
                          >SDE_READ_WRITE_PERMISSIONS</label
                        >
                      }
                    </div>
                    @if (
                      this.inputCloudRepoIsInvalid && !selectedInputCloudRepo
                    ) {
                      <label class="invalid-options mt-1" xdaTranslate
                        >SDE_SELECT_REPOSITORY1</label
                      >
                    }
                  </div>
                }
                <!-- email -->
                @if (inputSource.value == 'SDE_EMAIL2') {
                  <div class="input-choice">
                    @if (!emailOptions.emailAddress) {
                      <div>
                        <label [xdaTranslate]="'SDE_SIGN_INTO_MS'"></label>
                        <div>
                          <button
                            type="button"
                            class="xrx-btn btn-secondary btn btn-email-sign-in"
                            (click)="signInEmail()">
                            <span [xdaTranslate]="'SDE_SIGN_IN'"></span>
                          </button>
                        </div>
                        @if (errorInput) {
                          <label class="invalid-options mt-1" xdaTranslate>{{
                            errorInput
                          }}</label>
                        }
                      </div>
                    } @else {
                      <label [xdaTranslate]="'SDE_MS_EXCHANGE_ONLINE'"></label>
                      <div class="d-flex email-address-wrapper">
                        <xrx-input
                          type="text"
                          id="inputEmail"
                          name="inputEmail"
                          class="email"
                          [(ngModel)]="emailOptions.emailAddress"
                          [maxlength]="254"
                          [readonly]="true"
                          [required]="true"></xrx-input>
                        <button
                          type="button"
                          class="xrx-btn btn-secondary ml-2"
                          (click)="changeEmailAccount()">
                          <span [xdaTranslate]="'SDE_CHANGE'"></span>
                        </button>
                      </div>
                    }
                  </div>
                }
                <div class="h-divider"></div>
                <div class="page-selector">
                  <label [xdaTranslate]="'SDE_PAGE_RANGE'"></label>
                  <div>
                    <xrx-radio
                      display="inline"
                      [list]="pageRangeOptions"
                      property="value"
                      localize="label"
                      [(checkedItem)]="pageRangeOption">
                    </xrx-radio>
                  </div>
                  @if (pageRangeOption.value == 'SDE_SELECT_PAGES') {
                    <div class="input-selection">
                      <xrx-input
                        type="text"
                        (keyup)="rangeOnKeyUp()"
                        [(ngModel)]="input.selectedPages"
                        [autofocus]="false"
                        [required]="false"
                        [error]="input.selectedPagesError"
                        id="pageRange"
                        name="pageRange"
                        [pattern]="input.selectedPagesValidation"
                        [patternerror]="input.selectedPagesValidationError"
                        placeholder="SDE_ENTER_PAGE_RANGE1"></xrx-input>
                      <div class="page-select-help d-flex flex-column">
                        <span
                          class="info"
                          [xdaTranslate]="'SDE_ADD_COMMAS_DASHES'"></span>
                        <span
                          class="info"
                          [xdaTranslate]="'SDE_PAGE_SELECTOR_SUPPORTS'"
                          [formatValues]="supportedFileTypes"></span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="reset">
              <button
                type="button"
                class="xrx-btn btn-secondary btn-sm"
                (click)="resetInputSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_INPUT'"></span>
              </button>
            </div>
          }

          <!--Condition settings-->
          @case ('conditions') {
            <div class="settings">
              <div class="form-group">
                <h5
                  class="section-label"
                  [xdaTranslate]="'SDE_CONDITIONS'"></h5>
              </div>
              @if (inputSource.value == 'SDE_EMAIL2') {
                <div class="form-group">
                  <label [xdaTranslate]="'SDE_FROM_EMAIL_ADDRESS'"></label>
                  <div class="mb-20">
                    <xrx-radio
                      display="inline"
                      [list]="matchOptions"
                      property="value"
                      localize="label"
                      [(checkedItem)]="emailMatchOption"
                      (checkedItemChange)="
                        selectEmailMatchOption($event, 'email')
                      ">
                    </xrx-radio>
                    <xrx-input
                      type="text"
                      name="emailMatch"
                      [(ngModel)]="emailOptions.from.queryStr"
                      [maxlength]="254"
                      classes="textField medium"
                      (isValid)="matchConditionValidation($event)"
                      placeholder="{{
                        emailMatchOption.value == 0
                          ? addressPlaceholder
                          : containingPlaceholder
                      }}"
                      error="{{ errorConditions }}"></xrx-input>
                  </div>
                  <label [xdaTranslate]="'SDE_EMAIL_SUBJECT'"></label>
                  <div>
                    <xrx-radio
                      display="inline"
                      [list]="matchOptions"
                      property="value"
                      localize="label"
                      [(checkedItem)]="subjectMatchOption"
                      (checkedItemChange)="
                        selectEmailMatchOption($event, 'subject')
                      ">
                    </xrx-radio>
                    <xrx-input
                      type="text"
                      name="subjectMatch"
                      [(ngModel)]="emailOptions.subject.queryStr"
                      [maxlength]="100"
                      classes="textField medium"
                      (isValid)="matchConditionValidation($event)"
                      placeholder="{{
                        subjectMatchOption.value == 0
                          ? subjectPlaceholder
                          : containingPlaceholder
                      }}"
                      error="{{ errorConditions }}"></xrx-input>
                  </div>
                  <div class="h-divider"></div>
                  <label [xdaTranslate]="'SDE_CONTENT_BE_PROCESSED'"></label>
                  <div class="cb mb-8">
                    <xrx-checkbox
                      label="SDE_ATTACHMENTS"
                      [(checkBoxValue)]="emailOptions.processAttachments"
                      stop-event-propagation></xrx-checkbox>
                  </div>
                  <div class="cb mb-8">
                    <xrx-checkbox
                      label="SDE_MESSAGE_BODY"
                      [(checkBoxValue)]="emailOptions.processMessage"
                      stop-event-propagation></xrx-checkbox>
                  </div>
                  @if (
                    !emailOptions.processAttachments &&
                    !emailOptions.processMessage
                  ) {
                    <label class="invalid-options" xdaTranslate
                      >SDE_SELECT_ATTACHMENTS_MESSAGE</label
                    >
                  }
                  <div class="h-divider"></div>
                </div>
              }
              <label [xdaTranslate]="'SDE_OCCURRENCE'"></label>
              <div class="occurrence">
                <xrx-radio
                  [list]="occurrenceOptions"
                  property="value"
                  localize="label"
                  [(checkedItem)]="occurrenceOption">
                </xrx-radio>
                @if (occurrenceOption.value == Occurrence.Daily) {
                  <div>
                    <xrx-time
                      [(time)]="occurrenceTime"
                      placement="{{
                        inputSource.value == 'SDE_EMAIL2' ? 'auto' : ''
                      }}"></xrx-time>
                  </div>
                }
                @if (occurrenceOption.value == Occurrence.Weekly) {
                  <div>
                    <xrx-select
                      [list]="occurrenceDaysOfTheWeek"
                      localize="key"
                      property="value"
                      [(selectedItem)]="selectedDayOfTheWeek"
                      class="occurrence-days-of-the-week">
                    </xrx-select>
                    <xrx-time
                      class="occurrence-weekly-time"
                      [(time)]="occurrenceTime"
                      placement="{{
                        inputSource.value == 'SDE_EMAIL2' ? 'auto' : ''
                      }}"></xrx-time>
                  </div>
                }
              </div>
            </div>
            <div class="reset">
              <button
                type="button"
                class="xrx-btn btn-secondary btn-sm"
                (click)="resetConditionsSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_CONDITIONS'"></span>
              </button>
            </div>
          }

          <!-- Workflow settings -->
          @case ('workflow') {
            <div class="settings">
              <div class="form-group">
                <h5 class="section-label" [xdaTranslate]="'SDE_WORKFLOW'"></h5>
              </div>
              <div class="form-group service-selection">
                <xrx-select
                  inlineLabel="SDE_SELECT_WORKFLOW1"
                  [list]="workflows"
                  localize="name"
                  property="name"
                  class="workflow-name"
                  [(selectedItem)]="selectedWorkflow"
                  (change)="selectWorkflow($event)"
                  [ngClass]="{
                    'workflow-selected': selectedWorkflow,
                  }"></xrx-select>
                @if (!selectedWorkflow && !serviceIsSelected) {
                  <label class="invalid-options mt-1" xdaTranslate
                    >SDE_SELECT_WORKFLOW2</label
                  >
                }
              </div>
              @if (ignorePageRange) {
                <div class="ignorePageRange">
                  <span class="xglsize-24 xgl-alert_alt warning"></span>
                  <span class="warning" xdaTranslate
                    >SDE_PAGE_RANGE_SETTINGS</span
                  >
                </div>
              }
              <div class="h-divider"></div>
              <div class="service-settings">
                @for (
                  servSetting of serviceSettings;
                  track servSetting;
                  let i = $index
                ) {
                  <div>
                    @if (i === servicePageIndex) {
                      <div>
                        <div
                          class="service-params service-{{
                            servSetting.name | lowercase | slice: 4
                          }}">
                          @for (
                            param of servSetting.settings;
                            track param;
                            let i = $index;
                            let last = $last
                          ) {
                            <div
                              class="service-param pram-{{ param.name }}"
                              [ngClass]="{
                                'service-param-flow':
                                  param.type === 4 || param.type === 11,
                              }">
                              <xrx-setting
                                [(setting)]="servSetting.settings[i]"
                                [isAutomated]="true"
                                (validation)="
                                  validateServiceSettings($event, param)
                                "></xrx-setting>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="reset">
              @if (showResetServiceSettings) {
                <button
                  type="button"
                  class="xrx-btn btn-secondary btn-sm"
                  (click)="resetServiceSettings()">
                  <span
                    class="btn-label"
                    [xdaTranslate]="'SDE_RESET_WORKFLOW'"></span>
                </button>
              }
            </div>
          }

          <!-- Output settings -->
          @case ('output') {
            <div class="settings">
              <div class="form-group">
                <h5 class="section-label" [xdaTranslate]="'SDE_OUTPUT'"></h5>
              </div>
              <div class="form-group output-settings">
                @if (output.outputType !== OutputType.email) {
                  <div>
                    <div class="form-group">
                      @if (
                        inputSource.value == 'SDE_CLOUD_REPO' ||
                        (inputSource.value == 'SDE_EMAIL2' &&
                          emailOptions.processAttachments)
                      ) {
                        <span
                          [xdaTranslate]="'SDE_FILES_PROCESSED_USING'"></span>
                      }
                      <span>&nbsp;</span>
                      @if (
                        inputSource.value == 'SDE_EMAIL2' &&
                        emailOptions.processMessage
                      ) {
                        <span
                          [xdaTranslate]="'SDE_EMAIL_MESSAGE_CONTENT'"></span>
                      }
                    </div>
                    <!-- output file type -->
                    @if (
                      isTranslateWorkflow || output.fileTypes.asArray.length > 1
                    ) {
                      <label [xdaTranslate]="'SDE_FILE_TYPE'"></label>
                    }
                    <div class="file-name d-flex">
                      <div class="output-file-ext">
                        @if (
                          !isTranslateWorkflow &&
                          output.fileTypes.asArray.length > 1
                        ) {
                          <div>
                            <xrx-select
                              [list]="output.fileTypes.asArray"
                              property="value"
                              localize="key"
                              [(selectedItem)]="
                                output.fileTypes.extension
                              "></xrx-select>
                          </div>
                        }
                        @if (isTranslateWorkflow) {
                          <div>
                            <xrx-radio
                              [list]="translateFileTypes"
                              property="value"
                              localize="display"
                              [(checkedItem)]="
                                selectedTranslateFileType
                              "></xrx-radio>
                          </div>
                        }
                      </div>
                      <ng-template #retainInputTypeTooltip>
                        <div class="d-flex flex-column">
                          <span
                            [xdaTranslate]="'SDE_MICROSOFT_OFFICE_DOCUMENTS'"></span>
                          <span [xdaTranslate]="'SDE_IMAGE_RTF_FILES'"></span>
                        </div>
                      </ng-template>
                      @if (isTranslateWorkflow) {
                        <div class="auto-type-tooltip">
                          <i
                            class="glyph-style xgl-help"
                            [ngbTooltip]="retainInputTypeTooltip"></i>
                        </div>
                      }
                    </div>
                    <div class="h-divider"></div>
                    <!-- output destination -->
                    <label [xdaTranslate]="'SDE_DESTINATION'"></label>
                    <div>
                      <xrx-radio
                        [list]="output.selector.items"
                        property="value"
                        localize="label"
                        [(checkedItem)]="outputOption"
                        (change)="selectOutput($event)"></xrx-radio>
                    </div>
                    <!-- cloud output option -->
                    @if (output.selector.items[1].isOn) {
                      <div class="output-choice">
                        @if (outputCloudRepos.length > 1) {
                          <div>
                            <xrx-select
                              inlineLabel="SDE_SELECT_REPOSITORY"
                              [list]="outputCloudRepos"
                              localize="key"
                              property="key"
                              [(selectedItem)]="selectedOutputCloudRepo"
                              (change)="
                                selectCloudRepoOutput($event)
                              "></xrx-select>
                            @if (
                              this.outputCloudRepoIsInvalid &&
                              !this.selectedOutputCloudRepo
                            ) {
                              <label class="invalid-options mt-1" xdaTranslate
                                >SDE_SELECT_REPOSITORY1</label
                              >
                            }
                          </div>
                        }
                        @if (selectedOutputCloudFolder) {
                          <div class="selected-cloud-folder form-inline">
                            <div class="form-control d-flex align-items-center">
                              <span
                                class="xglsize-24"
                                [ngClass]="
                                  selectedOutputCloudFolder.type === 'lib'
                                    ? 'xgl-accounting'
                                    : 'xgl-folder'
                                "></span>
                              <div
                                class="cloud-folder-name text-truncate"
                                [xdaTranslate]="
                                  selectedOutputCloudFolder.name
                                "></div>
                            </div>
                            <button
                              type="button"
                              class="xrx-btn btn-secondary ml-2"
                              (click)="
                                changeOutputCloudFolder(selectedOutputCloudRepo)
                              "
                              xdaTranslate>
                              SDE_CHANGE
                            </button>
                          </div>
                        }
                        @if (
                          selectedOutputCloudRepo && !selectedOutputCloudFolder
                        ) {
                          <div class="selected-cloud-folder">
                            <button
                              type="button"
                              class="xrx-btn btn-secondary"
                              (click)="
                                changeOutputCloudFolder(selectedOutputCloudRepo)
                              "
                              xdaTranslate>
                              SDE_SELECT_FOLDER
                            </button>
                            <div>
                              @if (this.outputCloudRepoIsInvalid) {
                                <label class="invalid-options mt-1" xdaTranslate
                                  >SDE_SELECT_FOLDER1</label
                                >
                              }
                            </div>
                          </div>
                        }
                        <label class="info" xdaTranslate
                          >SDE_READ_WRITE_PERMISSIONS</label
                        >
                      </div>
                    }
                  </div>
                } @else {
                  @if (
                    workflow.output.settingTitle ==
                    'SDE_FAX_TRANSMISSION_REPORT'
                  ) {
                    <label
                      [xdaTranslate]="workflow.output.settingTitle"></label>
                  }
                  <xrx-toggle-switch
                    [label]="output.emailOptions.label.value"
                    [glyph]="output.emailOptions.glyph.value"
                    [switchOn]="output.selector.items[0].isOn"
                    (toggle)="
                      updateOutputOptions(output.selector.items[0])
                    "></xrx-toggle-switch>
                }
                <!-- email output option-->
                @if (output.selector.items[0].isOn) {
                  <div class="output-choice">
                    @if (
                      this.serviceSettings[this.servicePageIndex].name !==
                      'SDE_DOCUMENT_PROTECTION'
                    ) {
                      <div>
                        @if (allowedEmailDomains) {
                          <div class="info mb-2">
                            {{ allowedEmailDomains }}
                          </div>
                        }
                        <xrx-input
                          type="email"
                          id="recipientEmail"
                          class="recipientEmail"
                          name="recipientEmail"
                          [(ngModel)]="output.email"
                          [maxlength]="254"
                          placeholder="SDE_ENTER_ADDRESS2"
                          [required]="true"
                          label="SDE_RECIPIENT_EMAIL"></xrx-input>
                        <xrx-input
                          type="email"
                          id="confirmEmail"
                          class="confirmEmail"
                          name="confirmEmail"
                          [(ngModel)]="output.confirmEmail"
                          [maxlength]="254"
                          placeholder="SDE_CONFIRM_ADDRESS"
                          autocomplete="off"
                          [required]="true"
                          compareto="recipientEmail"
                          [compareCase]="false"
                          matcherror="SDE_RECIPIENT_CONFIRM_EMAILS"
                          label="SDE_CONFIRM_EMAIL1"
                          error="{{ errorEmail }}"></xrx-input>
                        @if (output.emailOptions.sendCondition.visible) {
                          <div class="output-choice-checkbox-wrapper">
                            <xrx-checkbox
                              label="SDE_EMAIL_REPORT_ONLY"
                              [(checkBoxValue)]="output.emailSendOnErrorValue"
                              name="onlyEmailFail"></xrx-checkbox>
                          </div>
                        }
                      </div>
                    } @else {
                      <label xdaTranslate>SDE_EMAIL_RECIPIENTS_SPECIFIED</label>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="reset">
              <button
                type="button"
                class="xrx-btn btn-secondary btn-sm"
                (click)="resetOutputSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_OUTPUT'"></span>
              </button>
            </div>
          }

          <!-- Name Settings -->
          @case ('name') {
            <div class="settings">
              <div class="form-group">
                <h5
                  class="section-label"
                  [xdaTranslate]="'SDE_NAME_AND_ICON'"></h5>
              </div>
              <div class="name-settings">
                <div>
                  <label [xdaTranslate]="'SDE_WORKFLOW_NAME'"></label>
                  <xrx-input
                    type="text"
                    id="name"
                    name="name"
                    [(ngModel)]="workflowName"
                    [required]="true"
                    [maxlength]="100"
                    error="{{ errorName }}"
                    [pattern]="output.fileNameValidation"
                    [patternerror]="output.fileNameError"></xrx-input>
                </div>
                <div class="h-divider"></div>
                <!--workflow icon-->
                <div class="mb-1">
                  <label [xdaTranslate]="'SDE_WORKFLOW_ICON'"></label>
                  <div>
                    <xrx-radio
                      display="inline"
                      [list]="iconOptions"
                      property="value"
                      localize="label"
                      [(checkedItem)]="iconOption"
                      (checkedItemChange)="selectIcon($event)"></xrx-radio>
                  </div>
                </div>
                <xrx-icon-picker
                  [(icon)]="selectedIcon!"
                  [(originalIcon)]="$any(selectedWorkflow!.icon)"
                  [(showDefault)]="iconOption.value"
                  [(iconSize)]="iconSize"></xrx-icon-picker>
                <div class="h-divider"></div>
                <label [xdaTranslate]="'SDE_ACTIVE'"></label>
                <xrx-toggle-switch
                  [switchOn]="isEnabled"
                  (toggle)="isEnabled = !isEnabled">
                </xrx-toggle-switch>
              </div>
            </div>
            <div class="reset">
              <button
                type="button"
                class="xrx-btn btn-secondary btn-sm"
                (click)="resetNameSettings()">
                <span
                  class="btn-label"
                  [xdaTranslate]="'SDE_RESET_NAME_ICON'"></span>
              </button>
            </div>
          }
        }
        <!--Navigation footer-->
        <div class="modal-footer">
          <div class="modal-footer-left cb">
            <button
              type="button"
              class="xrx-btn btn-secondary glyph xgl-close"
              data-dismiss="modal"
              (click)="activeModal.dismiss()"></button>
          </div>
          <div class="modal-footer-right">
            @if (step.index != 0) {
              <div class="cb">
                <button
                  type="button"
                  class="xrx-btn btn-secondary glyph xgl-navigate_left"
                  (click)="stepTo(steps[step.index - 1])"></button>
              </div>
            }
            @if (step.index < steps.length - 1) {
              <div class="cb">
                <button
                  type="button"
                  class="xrx-btn btn-secondary glyph xgl-navigate_right"
                  (click)="stepTo(steps[step.index + 1])"></button>
              </div>
            }
            @if (step.index == steps.length - 1 || !isNew) {
              <div class="cb">
                <button type="submit" class="xrx-btn btn-primary hide-mobile">
                  <span class="btn-label" [xdaTranslate]="'SDE_DONE'"></span>
                </button>
                <button
                  type="submit"
                  class="xrx-btn btn-primary glyph xgl-checkmark hide-desktop"></button>
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  </form>
}
